
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";

import { SnackbarProvider } from "notistack";
import { TintPicker } from "./TintPicker";
import { PriceChanger } from "./PriceChanger";

function App() {
  return (
    <Router basename="/">
      <SnackbarProvider>
        <Switch>
          <Route path="/secret-price-changer">
            <PriceChanger />
          </Route>
          <Route path="/">
            <TintPicker />
          </Route>
          <Redirect to="/" />
        </Switch>
      </SnackbarProvider>
    </Router>
  );
}

export default App;
